<template>
<div>
    <div v-if="!isLeserserviceOrHigher">
        Sie verfügen nicht über die Berechtigungen zum Anzeigen von Kunden.
    </div>
    <div v-if="isLeserserviceOrHigher" id="customer">
        <v-layout wrap>
            <v-flex md12>
                <div>
                    <v-progress-linear
                        :indeterminate="true"
                        :active="isLoading"
                        class="mb-2"
                    >
                    </v-progress-linear>
                </div>
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex md3>
                <CustomerActions class="mr-2 mb-2" />
                <Nutzerstatus
                    v-for="(cs, index) in customerStates"
                    :key="`customer-state-${index}`"
                    class="mr-2 mb-2"
                    :ssoId="cs.ssoId"
                    :icon="cs.icon"
                    :title="cs.title"
                    :text="cs.text"
                    :loading="info.loading"
                    :color="cs.color"
                    :status="cs.status"
                />
                <GpNummern
                    v-if="!contractors.loading"
                    class="mr-2 mb-2"
                    :ssoId="ssoId"
                    :gpNummern="gpNummern"
                    :disabled="contractors.loading"
                    @reload="reloadContractors"
                />
                <LinkedAccountsSummary
                    class="mr-2 mb-2"
                    v-if="!linkedAccountsSummary.loading && ((linkedAccountsSummary.data.assigned + linkedAccountsSummary.data.unassigned > 0) || linkedAccountsSummary.data.ownages.length > 0)"
                    :ssoId="ssoId"
                    :showButton="true"
                    :showParent="true"
                    :loading="linkedAccountsSummary.loading"
                    :linkedAccounts="linkedAccountsSummary.data"
                />
                <InfoBox
                    v-for="(ib, index) in infoBoxes"
                    :key="`info-box-${index}`"
                    class="mr-2 mb-2"
                    :icon="ib.icon"
                    :title="ib.title"
                    :text="ib.text"
                    :color="ib.color"
                />
            </v-flex>
            <v-flex md9>
                <!--Sessions class="ml-2 mb-2" :ssoId="ssoId" /-->
                <Sap class="ml-2 mb-2" />
                <Entitlements class="ml-2 mb-2" />
                <Purchases class="ml-2 mb-2" />
                <Sessions class="ml-2 mb-2" :ssoId="ssoId" />
                <v-layout class="ml-2 mb-2" v-if="isAdminOrHigher">
                    <v-flex md6>
                        <Nutzereigenschaften class="mr-2" />
                    </v-flex>
                    <v-flex md6>
                        <Optins class="ml-2" />
                    </v-flex>
                </v-layout>
                <Nutzergruppen class="ml-2"  v-if="isAdminOrHigher" />
            </v-flex>
        </v-layout>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import CustomerActions from '@/components/customer/CustomerActions.vue';
import InfoBox from '@/components/customer/InfoBox.vue';
import Nutzerstatus from '@/components/customer/Nutzerstatus.vue';
import Sap from '@/components/customer/Sap.vue';
import Entitlements from '@/components/customer/Entitlements.vue';
import Purchases from '@/components/customer/Purchases.vue';
import Sessions from '@/components/customer/Sessions.vue';
import Nutzereigenschaften from '@/components/customer/Nutzereigenschaften.vue';
import Optins from '@/components/customer/Optins.vue';
import Nutzergruppen from '@/components/customer/Nutzergruppen.vue';
import GpNummern from '@/components/customer/GpNummern.vue';
import LinkedAccountsSummary from '@/components/customer/LinkedAccountsSummary.vue';

export default {
    name: 'customer',
    components: {
        Purchases,
        Entitlements,
        Nutzereigenschaften,
        Optins,
        Nutzergruppen,
        CustomerActions,
        GpNummern,
        Sessions,
        InfoBox,
        Nutzerstatus,
        Sap,
        LinkedAccountsSummary,
    },
    mounted() {
        this.initState(this.$route.params.sso_id);
    },
    computed: {
        ...mapGetters('customerDetail', [
            'isLoading',
            'infoBoxes',
            'gpNummern',
            'customerStates',
        ]),
        ...mapGetters(['isLeserserviceOrHigher', 'isAdminOrHigher']),
        ...mapState('customerDetail', ['info', 'contractors', 'linkedAccountsSummary']),
        ssoId() {
            return this.$route.params.sso_id;
        },
    },
    methods: {
        ...mapActions('customerDetail', [
            'initState',
            'getContractors',
            'getPurchasesSapMhn',
            'getPurchasesSapNoz',
            'getPurchasesCeleraone',
            'getEntitlements',
        ]),
        reloadContractors() {
            this.getContractors();
            this.getPurchasesSapMhn();
            this.getPurchasesSapNoz();
            this.getPurchasesCeleraone();
            this.getEntitlements();
        },
    },
};
</script>

<style scoped lang="scss">
    @import "@/style/colors.scss";
    .customer__link {
        color: $white;
    }
</style>
